import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsAStreamableAddress Returns whether the URL is a Streamable address
 * @param url
 */
export const urlIsAStreamableAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.Streamable;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
